/**
 * Utility used for finding the closest angle for CSS rotations to ensure
 * rotation is done in the direction that is the shortest distance
 */
const closestEquivalentAngle = (from: number, to: number) => {
  const delta = ((((to - from) % 360) + 540) % 360) - 180;
  return from + delta;
};

export default closestEquivalentAngle;
